export const SOCKET_EVENTS = {
  SETTLEMENT_UPDATED: "settlement:updated",
  TRANSACTION_UPDATED: "transaction:updated",
  WALLET_CHANGED: "wallet_changed",
  USER_UPDATED: "user_updated",
};